import React from "react";
import styled from "styled-components";
import { MediaRef, Media } from "../../lib/CmsApi";
import Label from "./Label";
import { colors, spacing } from "../theme";
import { responsiveImageSrcset } from "../../lib/responsiveImage";

const Image = styled.img`
  width: 100%;
`;

const Caption = styled(Label)`
  width: 100%;
  color: ${colors.darkgrey};
  ${spacing("margin-top", 24)}
`;

interface Props {
  image: string | Media & MediaRef;
  caption?: string;
}

export default function ImageWithCaption({ image, caption, ...p }: Props) {
  return (
    <div {...p}>
      <Image
        {...responsiveImageSrcset({ image })}
        alt={typeof image !== "string" && image.alt ? image.alt : caption || ""}
      />
      {caption && (
        <Caption tiny regular>
          {caption}
        </Caption>
      )}
    </div>
  );
}

ImageWithCaption.getImages = ({ image }: Props) => {
  return image ? [image] : [];
};
